import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"
import { liveModeConstants } from "@data/constants/liveModeConstants"
import moment from "moment"

const initialState = {
    // { "<next_occurrence_id>": <acknowledgedAtMs>, ... }
    history: {},
}

/**
 * Acquittements, persistés, du pop-up de débordement du tuteur — un par
 * occurrence suivante. Ceux de plus de 24 h tombent au suivant.
 */
export function tutorOverrunAck(state = initialState, action) {
    switch (action.type) {
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
        case authService.revokeSanctumToken.name + apiConstants._SUCCESS:
        case authService.deleteAccount.name + apiConstants._SUCCESS:
            return initialState

        case liveModeConstants.ACK_TUTOR_OVERRUN: {
            const now = moment().valueOf()
            const cutoff = moment(now).subtract(24, "hours").valueOf()
            const recent = Object.entries(state.history).filter(([, at]) => at > cutoff)

            return {
                ...state,
                history: { ...Object.fromEntries(recent), [action.occurrenceId]: now },
            }
        }

        default:
            return state
    }
}

export function isOverrunAcknowledged(state, occurrenceId) {
    return !!occurrenceId && !!state?.history?.[occurrenceId]
}
